const getPreferenceCenterSmsPreferenceSection = require("./getPreferenceCenterSmsPreferenceSection");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function showPreferenceCenterSmsSection(preferenceCenter) {
    const smsSection = getPreferenceCenterSmsPreferenceSection(preferenceCenter);
    smsSection.style.display = "";
}